import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";

import t from "../../../i18n/i18n";
import useApi from "../../../services/api";
import { handleApiErrors } from "../../../utils/handleErrors";

import Notify from "../../../components/notification/notify";
import { isFeatureEnabled } from "../../../utils/isFeatureEnabled";

function PaymentBox({ step, credit }) {
  const [payment, setPayment] = useState({});
  const {
    user: { credits },
  } = useSelector((store) => store.auth);

  const { ApiCheckout } = useApi();

  const cart = useSelector((store) => store.cart);

  useEffect(() => {
    setPayment({});
  }, [cart]);

  function handleSelectRadio(e) {
    if (Object.keys(cart).length === 0) return Notify({ type: "danger", message: t("Errors.EmptyCart") });

    setPayment({ method: e.target.value });
  }

  async function SubmitCheckout() {

    if (!payment.method) return Notify({ type: "danger", message: t("Errors.EmptyPaymentMethod") });
    if (payment.method === "credit")
      return Notify({ type: "danger", message: "Sistema em manutenção" });

    if (cart.cupom) {
      const insufficientCredits = payment.method === "credit" && cart.cupom.credits > credits;
      if (insufficientCredits) return Notify({ type: "danger", message: t("Errors.InsufficientCredits") });
    }

    function handleCart() {
      if (cart.loyalMember)
        return { price: cart.loyalMember.price, count: cart.count, type: "loyalMember", variant: cart.loyalMember.id };
      if (cart.credit) return { price: cart.credit.price, count: cart.count, type: "credit", variant: cart.credit.id };
      if (cart.cupom)
        return { price: cart.cupom.price, count: cart.count, type: "cupom", variant: cart.cupom.id, form: cart.form };
    }

    const item = handleCart();

    const { data } = await ApiCheckout({
      gateway: payment.method,
      ...item,
    });

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    if (payment.method === "stripe") {
      const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHED_KEY);
      const stripe = await stripePromise;

      return await stripe.redirectToCheckout({ sessionId: data.redirect });
    }

    return window.location.replace(data.redirect);
  }

  return (
    <>
      <div className="chargin-box-panel">
        <div className="select-payment-method">
          <h3>
            <span className="step-counter">{step || "2"}</span> {t("RechargeCenter.Payment.Step")}
          </h3>

          <ul className="payment-method-list">
            {isFeatureEnabled("PAYPAL") && (
              <li>
                <div className="payment-box-main">
                  <div className="input-radio-box">
                    <input
                      type="radio"
                      value="paypal"
                      name="payment"
                      id="payment-paypal"
                      checked={payment.method === "paypal"}
                      onClick={handleSelectRadio}
                    />
                    <label for="payment-paypal">
                      <span className="payment-ico">
                        <img src="/images/payments/paypal.png" alt="" />
                      </span>
                      <span className="link-title">{t("Payment.Paypal")}</span>
                    </label>
                  </div>
                </div>
              </li>
            )}
            {isFeatureEnabled("MERCADOPAGO") && (
              <li>
                <div className="payment-box-main">
                  <div className="input-radio-box">
                    <input
                      type="radio"
                      value="mercadopago"
                      name="payment"
                      id="payment-mercadopago"
                      checked={payment.method === "mercadopago"}
                      onClick={handleSelectRadio}
                    />
                    <label for="payment-mercadopago">
                      <span className="payment-ico">
                        <img src="/images/payments/mercadopago.png" alt="" />
                      </span>
                      <span className="link-title">{t("Payment.MercadoPago")}</span>
                    </label>
                  </div>
                </div>
              </li>
            )}
            {isFeatureEnabled("PICPAY") && (
              <li>
                <div className="payment-box-main">
                  <div className="input-radio-box">
                    <input
                      type="radio"
                      value="picpay"
                      name="payment"
                      id="payment-picpay"
                      checked={payment.method === "picpay"}
                      onClick={handleSelectRadio}
                    />
                    <label for="payment-picpay">
                      <span className="payment-ico">
                        <img src="/images/payments/picpay.png" alt="" />
                      </span>
                      <span className="link-title">{t("Payment.PicPay")}</span>
                    </label>
                  </div>
                </div>
              </li>
            )}
            {isFeatureEnabled("STRIPE") && (
              <li>
                <div className="payment-box-main">
                  <div className="input-radio-box">
                    <input
                      type="radio"
                      value="stripe"
                      name="payment"
                      id="payment-stripe"
                      checked={payment.method === "stripe"}
                      onClick={handleSelectRadio}
                    />
                    <label for="payment-stripe">
                      <span className="payment-ico">
                        <img src="/images/payments/stripe.png" alt="" />
                      </span>
                      <span className="link-title">{t("Payment.Stripe")}</span>
                    </label>
                  </div>
                </div>
              </li>
            )}

            {isFeatureEnabled("COINBASE") && (
              <li>
                <div className="payment-box-main">
                  <div className="input-radio-box">
                    <input
                      type="radio"
                      value="coinbase"
                      name="payment"
                      id="payment-coinbase"
                      checked={payment.method === "coinbase"}
                      onClick={handleSelectRadio}
                    />
                    <label for="payment-coinbase">
                      <span className="payment-ico">
                        <img src="/images/payments/coinbase.png" alt="" />
                      </span>
                      <span className="link-title">{t("Payment.Coinbase")}</span>
                    </label>
                  </div>
                </div>
              </li>
            )}

            {/*credit && (Object.keys(cart).length === 0 || cart?.cupom?.credits > 0) && (
              <li>
                <div className="payment-box-main">
                  <div className="input-radio-box">
                    <input
                      type="radio"
                      value="credit"
                      name="payment"
                      id="payment-credit"
                      checked={payment.method === "credit"}
                      onClick={handleSelectRadio}
                    />
                    <label for="payment-credit">
                      <span className="payment-ico">
                        <img src="/images/credit-ico-large.png" alt="" />
                      </span>
                      <span className="link-title">{t("Payment.Credit")}</span>
                    </label>
                  </div>
                </div>
              </li>
            )*/}
          </ul>
        </div>
      </div>
      <div className="panel-button">
        <button type="button" className="payment-btn btn-primary" onClick={SubmitCheckout}>
          <span className="ico">
            <img src="images/cart-ico.png" alt="" />
          </span>
          {t("Payment.BuyNow")}
        </button>
      </div>
    </>
  );
}

export default PaymentBox;
